var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import { css, mq, styled } from "../../utils";
import ContactDesktop from './ContactDesktop';
var StyledHeader = styled.div(function (_a) {
    var space = _a.theme.space;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: static;\n    align-items: center;\n    padding: 0 ", " ", ";\n    justify-content: space-between;\n\n    ", ";\n  "], ["\n    position: static;\n    align-items: center;\n    padding: 0 ", " ", ";\n    justify-content: space-between;\n\n    ", ";\n  "])), space[6], space[3], mq({
        display: ['none', 'flex'],
    }));
});
var HeaderDesktop = function (_a) {
    var logo = _a.logo, contactLabel = _a.contactLabel, contactPhone = _a.contactPhone, contactPhoneHref = _a.contactPhoneHref;
    return (React.createElement(StyledHeader, null,
        React.createElement(ContactDesktop, { label: contactLabel, phone: contactPhone, phoneHref: contactPhoneHref }),
        logo));
};
export default HeaderDesktop;
var templateObject_1;
//# sourceMappingURL=HeaderDesktop.js.map